import { MatStepperIntl } from '@angular/material/stepper';

export function customStepperIntl() {
  const matStepperIntl = new MatStepperIntl();
  matStepperIntl.optionalLabel = 'Opcional';

  return matStepperIntl;
}